import React, { useState } from 'react';

const PLANS = [
  {
    id: 'starter',
    name: 'Starter',
    price: '79',
    credits: '20',
    desc: '~1-2 Kampagnen',
    priceId: 'price_1TLoRTD7CxEmO9BBdyXJYLyA',
  },
  {
    id: 'pro',
    name: 'Pro',
    price: '159',
    credits: '80',
    desc: '~6-7 Kampagnen',
    priceId: 'price_1TLoRUD7CxEmO9BBnjEq8Lmm',
    recommended: true,
  },
  {
    id: 'agency',
    name: 'Agency',
    price: '349',
    credits: '250',
    desc: '~20 Kampagnen',
    priceId: 'price_1TLoRVD7CxEmO9BB2R0V6J9R',
  },
];

const EXTRA_PRICE_ID = 'price_1TLoRVD7CxEmO9BB8k7uo6aW';

export default function UpgradeModal({ isOpen, onClose, user, currentPlan, currentCredits }) {
  const [loading, setLoading] = useState(null);

  if (!isOpen) return null;

  const handleCheckout = async (priceId) => {
    setLoading(priceId);
    try {
      const res = await fetch('https://api.recruifly.de/api/stripe/create-checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: user.id, priceId, email: user.email }),
      });
      const { url } = await res.json();
      if (url) window.location.href = url;
    } catch (err) {
      alert('Fehler: ' + err.message);
    } finally {
      setLoading(null);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: '20px'
    }} onClick={onClose}>
      <div style={{
        background: 'white', borderRadius: '20px', maxWidth: '780px', width: '100%',
        maxHeight: '90vh', overflow: 'auto', boxShadow: '0 25px 50px rgba(0,0,0,0.25)'
      }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding: '28px 32px 20px', textAlign: 'center', position: 'relative' }}>
          <button onClick={onClose} style={{
            position: 'absolute', top: '16px', right: '16px', background: 'none', border: 'none',
            fontSize: '1.3rem', cursor: 'pointer', color: '#999', padding: '4px 8px'
          }}>x</button>
          <h2 style={{ margin: '0 0 6px', fontSize: '1.4rem', fontWeight: '800' }}>Credits aufgebraucht</h2>
          <p style={{ margin: 0, color: '#666', fontSize: '0.9rem' }}>
            Du hast noch <strong>{currentCredits ?? 0} Credits</strong>. Wähle einen Plan um weiterzumachen.
          </p>
          <p style={{ margin: '8px 0 0', color: '#999', fontSize: '0.78rem' }}>
            1 Bild = 1 Credit &middot; 1 Video = 3 Credits
          </p>
        </div>

        {/* Plans */}
        <div style={{ padding: '0 32px 24px', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '14px' }}>
          {PLANS.map(plan => {
            const isCurrent = currentPlan === plan.id;
            const isRecommended = plan.recommended;
            return (
              <div key={plan.id} style={{
                border: isRecommended ? '2px solid #6366f1' : '1.5px solid #e5e7eb',
                borderRadius: '14px', padding: '24px 20px', textAlign: 'center',
                background: isRecommended ? '#fafaff' : 'white', position: 'relative'
              }}>
                {isRecommended && (
                  <div style={{
                    position: 'absolute', top: '-10px', left: '50%', transform: 'translateX(-50%)',
                    background: '#6366f1', color: 'white', padding: '3px 14px', borderRadius: '99px',
                    fontSize: '0.68rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px'
                  }}>Empfohlen</div>
                )}
                <div style={{ fontSize: '1.05rem', fontWeight: '700', color: '#111', marginBottom: '4px' }}>{plan.name}</div>
                <div style={{ marginBottom: '12px' }}>
                  <span style={{ fontSize: '2rem', fontWeight: '800', color: '#111' }}>{plan.price}€</span>
                  <span style={{ fontSize: '0.82rem', color: '#888' }}>/Monat</span>
                </div>
                <div style={{ fontSize: '0.88rem', fontWeight: '600', color: '#6366f1', marginBottom: '4px' }}>
                  {plan.credits} Credits/Monat
                </div>
                <div style={{ fontSize: '0.75rem', color: '#999', marginBottom: '16px' }}>{plan.desc}</div>
                {isCurrent ? (
                  <div style={{
                    padding: '10px', borderRadius: '10px', background: '#f0fdf4',
                    color: '#166534', fontSize: '0.82rem', fontWeight: '600'
                  }}>Aktueller Plan</div>
                ) : (
                  <button onClick={() => handleCheckout(plan.priceId)}
                    disabled={loading === plan.priceId}
                    style={{
                      width: '100%', padding: '12px', borderRadius: '10px', border: 'none',
                      background: isRecommended ? '#6366f1' : '#111', color: 'white',
                      fontSize: '0.88rem', fontWeight: '700', cursor: 'pointer',
                      opacity: loading === plan.priceId ? 0.6 : 1
                    }}>
                    {loading === plan.priceId ? 'Weiterleitung...' : 'Jetzt upgraden'}
                  </button>
                )}
              </div>
            );
          })}
        </div>

        {/* Extra Credits */}
        <div style={{
          margin: '0 32px 28px', padding: '16px 20px', background: '#f9fafb',
          borderRadius: '12px', border: '1px solid #e5e7eb', display: 'flex',
          alignItems: 'center', justifyContent: 'space-between', gap: '16px', flexWrap: 'wrap'
        }}>
          <div>
            <div style={{ fontSize: '0.88rem', fontWeight: '600', color: '#111' }}>Noch nicht bereit für ein Abo?</div>
            <div style={{ fontSize: '0.78rem', color: '#666' }}>10 Credits für 5€ — einmalig, kein Abo</div>
          </div>
          <button onClick={() => handleCheckout(EXTRA_PRICE_ID)}
            disabled={loading === EXTRA_PRICE_ID}
            style={{
              padding: '10px 24px', borderRadius: '10px', border: '1.5px solid #d1d5db',
              background: 'white', color: '#111', fontSize: '0.85rem', fontWeight: '600',
              cursor: 'pointer', whiteSpace: 'nowrap', opacity: loading === EXTRA_PRICE_ID ? 0.6 : 1
            }}>
            {loading === EXTRA_PRICE_ID ? 'Weiterleitung...' : '10 Credits kaufen'}
          </button>
        </div>
      </div>
    </div>
  );
}
